@let gridConfigData = localGridConfig();


<section class="grid-title-event">
    <h2
      [attr.data-testid]="gridConfigData.gridDataTestId+'-list-title'">
        {{title | capitalize: 'all'}}
    </h2>

    <div class="events-container">
      @if(gridConfigData.replayButton) {
        <button
          [attr.data-testid]="gridConfigData.gridDataTestId+'-refresh-button'"
          [attr.aria-label]="gridConfigData.gridTitle+' Refresh grid'"
          mat-icon-button
          (click)="getItems()">
            <mat-icon fontIcon="replay" />
        </button>
      }
      @if(gridConfigData.eventButton){
        <div [matTooltip]="gridConfigData.eventButton.tooltip || ''"
             matTooltipPosition="above"
             [matTooltipDisabled]="!gridConfigData.eventButton.tooltip"
             [style.display]="'inline-block'">
          <button
            color="primary"
            [attr.data-testid]="gridConfigData.gridDataTestId+'-event-button'"
            [attr.aria-label]="gridConfigData.gridTitle+' Event Button'"
            [disabled]="gridConfigData.eventButton.disabled || false"
            mat-stroked-button
            (click)="!gridConfigData.eventButton.disabled && onEventButton()">
              @if (gridConfigData.eventButton.icon) {
                <mat-icon [fontIcon]="gridConfigData.eventButton!.icon" />
              }
              {{gridConfigData.eventButton.text}}
          </button>
        </div>
      }

      @if(gridConfigData.secondEventButton){
        <button
          color="primary"
          [attr.data-testid]="gridConfigData.gridDataTestId+'-second-event-button'"
          [attr.aria-label]="gridConfigData.gridTitle+' Second Event Button'"
          mat-stroked-button
          (click)="onSecondEventButton()">
            @if (gridConfigData.secondEventButton.icon) {
              <mat-icon [fontIcon]="gridConfigData.secondEventButton!.icon" />
            }
            {{gridConfigData.secondEventButton.text}}
        </button>
      }
      @if (items.length){
        <button
          class="btn-download"
          color="primary"
          [attr.data-testid]="gridConfigData.gridDataTestId+'-download-excel-button'"
          [attr.aria-label]="gridConfigData.gridTitle+' Download To Excel Button'"
          mat-stroked-button
          (click)="downloadGridToExcel()">
            <mat-icon fontIcon="download" />
        </button>
      }

      @if(gridConfigData.pdfButton && items.length){
        <button
          class="btn-download"
          color="primary"
          [attr.data-testid]="gridConfigData.gridDataTestId+'-download-pdf-button'"
          [attr.aria-label]="gridConfigData.gridTitle+' Download To PDF Button'"
          mat-stroked-button
          (click)="downloadGridToPdf()">
            <mat-icon>picture_as_pdf</mat-icon>
        </button>
      }
    </div>
</section>

<mat-table
  class="compact-mat-table"
  [dataSource]="items"
  (matSortChange)="onSortChanged($event)"
  [attr.data-testid]="gridConfigData.gridDataTestId+'-table'"
  matSort>
    @for (column of localGridConfig().columns; track column?.columnProperty) {
      <ng-container [matColumnDef]="column.columnProperty">
        @if(column.sort){
          <mat-header-cell
            class="mat-header-cell"
            *matHeaderCellDef
            mat-sort-header
            [attr.data-testid]="gridConfigData.gridDataTestId+'-'+column.columnProperty+'-header'"
            [ngClass]="{
              'hideOnMin' : column.hideOnSmallScreen,
              'mat-column-extra-width': column.extraWidth,
            }">
              {{column.columnHeader | capitalize: 'all'}}
          </mat-header-cell>
        } @else {
          <mat-header-cell
            class="mat-header-cell"
            *matHeaderCellDef
            [attr.data-testid]="gridConfigData.gridDataTestId+'-'+column.columnProperty+'-header'"
            [ngClass]="{
              'hideOnMin' : column.hideOnSmallScreen,
              'mat-column-extra-width': column.extraWidth,
            }">
            {{column.columnHeader | capitalize: 'all'}}
          </mat-header-cell>
        }
        <mat-cell
          *matCellDef="let element"
          class="mat-cell"
          [attr.data-testid]="gridConfigData.gridDataTestId+'-'+column.columnProperty+'-cell'"
          [ngClass]="{
            'hideOnMin' : column.hideOnSmallScreen,
            'flexible-content': column.flexContent,
            'mat-column-extra-width': column.extraWidth,
          }"
          [ngStyle]="column.style ? column.style(element) : {}">
          @let iconDisplayFunction = column.columnIconDisplayFunction ? column.columnIconDisplayFunction(element) : null;

          @let displayString = iconDisplayFunction ? '' :
            (column.columnPropertyFunction ? column.columnPropertyFunction(element) : element[column.columnProperty]);

          @if(iconDisplayFunction) {
            @if(!(column?.shouldHideCellContent && !column?.shouldHideCellContent(element))) {
            <button mat-icon-button color="primary" (click)="onClickColumn(column.columnProperty, element)">
              <mat-icon>{{iconDisplayFunction}}</mat-icon>
            </button>
            }
          }
          @if(column.columnIconDisplay) {
            @if(!(column?.shouldHideCellContent && !column?.shouldHideCellContent(element))){
              <button mat-icon-button color="primary" (click)="onClickColumn(column.columnProperty, element)">
                <mat-icon>{{column.columnIconDisplay}}</mat-icon>
              </button>
            }
          } @else {
            @if(!(column?.shouldHideCellContent && !column?.shouldHideCellContent(element))){
              @if(column.clickableWithItem ? column.clickableWithItem(element) : (column.clickable || column.linkEventFunction)) {
                  <span [ngClass]="{
                    'compact-mat-cell-text' : column.compactText,
                    'align-text-left': column.textLeft,
                    'mat-column-wrap': column.wrapContent,
                    }">
                      <a
                      [attr.href]="column.linkEventFunction?.(element, filters) ??  '#'"
                      (click)="checkPreventDefault(column?.disablePreventEventLink ?? false, $event);onClickColumn(column.columnProperty, element)"
                      [ngStyle]="column.linkStyle ? column.linkStyle(element) : {}"
                      target="_blank">
                      @if (column.processData) {
                        {{ column.processData(displayString) }}
                      } @else {
                        {{ displayString }}
                      }
                    </a>
                  </span>
              } @else {
                <span [ngClass]="{
                  'compact-mat-cell-text' : column.compactText,
                  'align-text-left': column.textLeft,
                  'mat-column-wrap': column.wrapContent,
                  }" [style.white-space]="column.whiteSpace ? column.whiteSpace : 'normal'">
                    @if (column.processData) {
                      {{ column.processData(displayString) }}
                    } @else {
                      {{ displayString }}
                    }
                </span>
              }
            }
          }

        </mat-cell>

        <mat-footer-cell
          *matFooterCellDef
          [attr.data-testid]="gridConfigData.gridDataTestId+'-'+column.columnProperty+'-footer'"
          [ngClass]="{
              'hideOnMin' : column.hideOnSmallScreen,
              'mat-column-extra-width': column.extraWidth,
          }">
            {{column.columnTotal}}
        </mat-footer-cell>

      </ng-container>
    }

    @if(gridConfigData.showActionColumn){
      <ng-container matColumnDef="actions">
        <mat-header-cell class="mat-header-cell" [attr.data-testid]="gridConfigData.gridDataTestId+'action-header'" *matHeaderCellDef>
            {{gridConfigData.actionColumnHeader || 'Actions'}}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-testid]="gridConfigData.gridDataTestId+'action-cell'">

          <ng-container
            [ngTemplateOutlet]="actionItem || defaultTemplate"
            [ngTemplateOutletContext]="{item: element}"
          ></ng-container>

          <ng-template #defaultTemplate>
            <p>No Action provided</p>
          </ng-template>
        </mat-cell>

        <mat-footer-cell *matFooterCellDef></mat-footer-cell>

      </ng-container>
    }
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" [attr.data-testid]="gridConfigData.gridDataTestId+'-header-row'" />
    <mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
             [ngClass]="getRowClass(row)"
             [ngStyle]="getRowStyle(row)"
             [matTooltip]="getRowTooltip(row)"
             [matTooltipDisabled]="!hasRowTooltip(row)"/>

    <mat-footer-row [ngStyle]="{ 'visibility': !!showTotals ? 'visible' : 'hidden' }" *matFooterRowDef="displayedColumns" [attr.data-testid]="gridConfigData.gridDataTestId+'-footer-row'" />

</mat-table>

<mat-paginator
  [attr.data-testid]="gridConfigData.gridDataTestId+'-paginator'"
  [length]="pagination.totalItemCount"
  [pageSizeOptions]="[5, 15,25, 50, 75, 100]"
  [pageSize]="pagination.pageSize"
  [pageIndex]="pagination.pageIndex"
  (page)="onPageChanged($event)"
/>
